import type { IconEntry } from '#layers/ui/modules/icon-search/generate-icon-index';
import Fuse from 'fuse.js';
import { computed, ref } from 'vue';
import { icons, totalCount } from '#build/icons/search-index';

const allIcons: IconEntry[] = [...icons];

const fuse = new Fuse(allIcons, {
	keys: [
		{ name: 'label', weight: 1 },
		{ name: 'terms', weight: 0.7 },
	],
	threshold: 0.35,
});

export function useIconSearch() {
	const search = ref('');

	const displayedIcons = computed<IconEntry[]>(() => {
		if (!search.value.trim()) return allIcons;
		return fuse.search(search.value).map((r) => r.item);
	});

	return { search, displayedIcons, totalCount };
}
